const Snippets = () => {
  return (
    <div>Snippets</div>
  )
}

export default Snippets